import { createEffect } from "solid-js"
import { type DirectionDxDy } from "src/lib/core/direction/DirectionDxDy.type"
import { DoubleSide, Group, Mesh, MeshBasicMaterial, PlaneGeometry, Vector3 } from "three"
import { dijkstraDirections } from "../../core/direction/dijkstraDirections"
import type { Engine } from "../../core/engine/Engine.type"
import { HALF_PI } from "../../core/util/math/Math"
import { VERTICES_PER_TILE } from "../consts"
import { RenderOrder } from "../RenderOrder.enum"
import useMainScene from "./useMainScene"

const bottomY = 40
export default function createMapEditorEdgeWallsGroupV2(
  engine: Engine,
): void {
  // console.log('createMapEditorEdgeWallsGroupV2')
  const scene = useMainScene(engine)

  const group: Group = new Group()
  group.name = 'MapEditorEdgeWallsGroup'
  group.renderOrder = RenderOrder.MapGridBorderWalls

  const dirGroupMap = new Map<DirectionDxDy, Mesh>

  const geometry = new PlaneGeometry(1, 1)
  const material = new MeshBasicMaterial({
    // color: 0xffff00,
    // opacity: 0.25,
    side: DoubleSide,
    transparent: true,
    color: 0x000000,
    // opacity: 0.25,
  })

  const whDiv = 4

  for (const dir of dijkstraDirections) {
    const { dx, dy } = dir
    const mesh = new Mesh(geometry, material)
    if (dy !== 0) {
      mesh.rotateZ(HALF_PI)
    } else {
      mesh.rotateY(HALF_PI)
    }
    mesh.position.set(dx, bottomY, dy)
    mesh.scale.multiply(new Vector3(
      VERTICES_PER_TILE / whDiv,
      VERTICES_PER_TILE / whDiv,
      VERTICES_PER_TILE))
    group.add(mesh)

    dirGroupMap.set(dir, mesh)
  }

  // console.log('group', group)

  const mult = VERTICES_PER_TILE
  createEffect(() => {
    const { width, height } = engine.state
    // console.log('effect', {width, height})

    const offsetX = ((width - 1) * VERTICES_PER_TILE / 2)
    const offsetZ = ((height - 1) * VERTICES_PER_TILE / 2)

    dirGroupMap.forEach((mesh, dir: DirectionDxDy) => {
      const { dx, dy } = dir
      // const scaleValue = 1.4
      if (dy !== 0) {
        // mesh.position.z = mult * dy * (width/2)
        mesh.position.z = (mult * dy * (height / 2)) + offsetZ
        mesh.position.x = offsetX
        // console.log('dy', dy, mesh.position.z)
        mesh.scale.y = mult * dy * width
      } else {
        // mesh.position.x = mult * dx * (height/2)
        mesh.position.x = (mult * dx * (width / 2)) + offsetX
        mesh.position.z = offsetZ
        mesh.scale.x = mult * dx * height
      }
      mesh.position.y = 0
    })
  })

  scene.add(group)
}
